export default "__VITE_PUBLIC_ASSET__a2c051a4__"